/*
* 报价产品管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Table, Input, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    winHeight,
    winWidth,
    isGTscreenWidth,
} from '../../incs/FunHelper.js';

const Lists = (props) => {
    const columns = [
        {
            title: '', key: 'key', fixed: 'left', width: 50,
            render: function (record) {
                return <Button
                    color='primary'
                    variant='link'
                    style={{ padding: 0, height: 20 }}
                    icon={<PlusOutlined />}
                    onClick={() => {
                        props.addProduct(record);
                    }}></Button>
            }
        },
        { title: '产品编码', dataIndex: 'number', key: 'number', fixed: 'left', width: 140, },
        { title: '产品名称', dataIndex: 'name', key: 'name', ellipsis: true, width: 300, },
        { title: '规格型号', dataIndex: 'model', key: 'model', ellipsis: true, width: 325, },
        { title: '供应商编码', dataIndex: 'supplier_number', key: 'supplier_number', width: 100, },
        { title: '品牌', dataIndex: 'brand', key: 'brand', ellipsis: true, width: 130, },
        { title: '单位', dataIndex: 'unit', key: 'unit', ellipsis: true, width: 80, },
        { title: '描述', dataIndex: 'description', key: 'description', ellipsis: true, width: 450, },
        { title: '单价(元)', dataIndex: 'price', key: 'price', fixed: 'right', width: 150, },
    ];
    return (
        <div style={{ width: winWidth > 200 ? winWidth - 245 : winWidth - 45, height: ((winHeight - 364) / 2 - 80) }}>
            <Table
                columns={columns}
                style={{ width: '100%' }}
                size='small'
                dataSource={props.dataLists}
                // virtual
                scroll={{
                    x: winWidth > 200 ? winWidth - 245 : winWidth - 45,
                    y: (winHeight - 364) / 2 - 85,
                }}
                bordered={true}
                pagination={false}
            />
        </div>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            init: 0,
            isRefresh: 0,
            pageCount: 0,
            dataLists: [],
            number: '',
            name: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    changeNumber = (e) => { this.setState({ number: e.target.value }); this.isRefresh(); }
    changeName = (e) => { this.setState({ name: e.target.value }); this.isRefresh(); }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.record !== nextProps.record) {
            this.setState({
                record: nextProps.record,
                number: '',
                name: '',
            })
        }
    }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'number': this.state.number,
            'name': this.state.name,
            'status': CNF.status[0].value,
            'page_size': CNF.pageSize * 10,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.scmsApi}products${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div style={{ width: '100%', height: (winHeight - 364) / 2 }}>
                <Row style={{ height: 45, paddingTop: 7 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeNumber}
                            placeholder='产品编码'
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <Input
                            onChange={this.changeName}
                            placeholder='产品名称'
                            value={this.state.name}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            addProduct={this.props.addProduct}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT